<div class="container">
  <div class="row">
    <div class="col-md-8 col-sm-8 col-xs-10">
      <h1 class="text-headline">{{ getFieldLabel("nl_heading_sms") }}</h1>

      <p>{{ getServiceLabel() }}</p>

      <form id="amcUnsubForm" [formGroup]="amcUnsubForm" (ngSubmit)="onSubmitUnsub()">
        <!-- mobile number -->
        <div class="form-group row">
          <label controlName="nl_mobile" class="col-md-3 col-sm-3 col-xs-4 col-xs-12 form-label">*
            {{ getFieldLabel("nl_mobile") }}</label>
          <div class="col-md-6 col-sm-9 col-xs-12">
            <input formControlName="mobilenumber" type="text" id="mobilenumber" name="mobilenumber" class="styled form-text required">
          </div>
          <div
            *ngIf="getFieldContent('mobilenumber').invalid && (getFieldContent('mobilenumber').dirty || getFieldContent('mobilenumber').touched)">
            <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
                   *ngIf="getFieldContent('mobilenumber').errors?.required; else templateName">{{ getFieldLabel("nl_err") }}</small>
            <ng-template #templateName>
              <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{ getFieldLabel("nl_err") }}</small>
            </ng-template>
          </div>
        </div>
        <!-- Button for submit -->
        <div class="form-group row">
          <div class="col-md-6 col-sm-6 col-md-offset-2 col-sm-offset-2 col-xs-6 col-xs-offset-4">
            <button type="submit" id="unsubButtonAngular" name="unsubButtonAngular"
                    class="button-rounded">{{ getFieldLabel("nl_unsub_btn") }}</button>
          </div>
          <small id="warning-missing"
                 class="col-md-2 col-sm-12 col-xs-12 form-label err hide">{{ getFieldLabel("nl_err_btn") }}</small>
        </div>
      </form>
    </div>
    <div class="col-md-4 col-sm-4 hidden-xs">
      <img class="img-responsive nlImg" src="{{ newsletterImage }}" />
    </div>
  </div>
</div>
